<div>
    <div class="form-group">
        <label tcc-labelForNext><b>Organization</b></label>
        <table width="100%">
            <col width="80%">
            <col width="20%">
            <tr>
                <td>
                    <select class="form-select" [(ngModel)]="selectedOrg" (change)="filterOrg()">
                        <option [ngValue]="undefined">Select One</option>
                        <option *ngFor="let o of orgs$ | async " [ngValue]="o">{{getOrgLabel(o)}}</option>
                    </select>
                </td>
                <td style="text-align: center;">
                    <div *ngIf="!addMode && selectedOrg">
                        <a (click)="AddToOrgClicked()" ngbTooltip="Add Account Split">
                            <i class="fa fa-plus" style="color: blue"></i>
                        </a>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div *ngIf="addMode" class="form-group">
        <label tcc-labelForNext>Account Split</label>
        <table width="100%">
            <col width="80%">
            <col width="20%">
            <tr>
                <td>
                    <select class="form-select" [(ngModel)]="selectedAccountSplit">
                        <option [ngValue]="undefined">Select One</option>
                        <option *ngFor="let s of accountSplits$ | async " [ngValue]="s">{{s.type}} - {{s.name}} {{s.orgCode}} {{s.account}} {{s.percentage}}</option>
                    </select>
                </td>
                <td style="text-align: center;">
                    <a (click)="AddManagementFeeAccountSplitClicked()" ngbTooltip="Add">
                        <i class="fa fa-plus" style="color: blue"></i>
                    </a>
                </td>
            </tr>
        </table>
    </div>
    <hr />

    <div *ngIf="filteredAccountSplits!.length > 0" style="text-align: center; float: right">
        <table width="50%">
            <col width="50%">
            <col width="25%">
            <col width="25%">
            <tr>
                <td rowspan="2" style="vertical-align: middle;">
                    <div *ngIf="isBalanced" style="color: green;"><p><i><b>Balanced</b></i></p></div>
                    <div *ngIf="!isBalanced" style="color: red;"><p><i><b>UnBalanced</b></i></p></div>
                </td>
                <td>Revenue Totals</td>
                <td>Expense Totals</td>
            </tr>
            <tr>
                <td>{{revsTotal | number:'1.4-4'}}</td>
                <td>{{expsTotal | number:'1.4-4'}}</td>
            </tr>
        </table>        
    </div>
    <div *ngIf="state === 'ready'" class="tcc-table-div">
        <tcc-table tableClass="table-sm small" [rows]="filteredAccountSplits" [columns]="columns" [buttons]="buttons"
            (cellClick)="rowClicked($event)">
        </tcc-table>
    </div>
</div>